var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1217123_apple_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0328 8.19373C20.6578 8.51248 20.2828 8.78904 19.9594 9.11248C18.2859 10.7953 18.1828 13.3172 19.0125 15.0515C19.5422 16.1578 20.3813 16.9547 21.4781 17.489C21.6469 17.5734 21.6844 17.6437 21.6188 17.8265C21.0844 19.2984 20.3578 20.6625 19.3594 21.8765C19.05 22.2562 18.7266 22.6312 18.375 22.9734C17.6578 23.6719 16.8 23.9765 15.8016 23.7562C15.375 23.6625 14.9438 23.5547 14.55 23.3765C13.3266 22.8281 12.0984 22.7765 10.8375 23.2125C10.2844 23.4047 9.73595 23.6109 9.17345 23.7609C8.29688 24 7.52345 23.7562 6.85313 23.1609C5.85001 22.2797 5.07188 21.225 4.40157 20.0765C3.53907 18.5906 2.9672 16.9922 2.64845 15.3094C2.33438 13.65 2.2922 11.9906 2.79845 10.35C3.12657 9.2906 3.6422 8.33435 4.45782 7.5656C5.7422 6.35154 7.25626 5.77967 9.01876 6.05154C9.65157 6.14998 10.275 6.37498 10.8656 6.63279C11.6813 6.98435 12.4547 7.10623 13.2984 6.71717C14.0109 6.38904 14.7609 6.12654 15.5438 5.99529C17.0953 5.73748 18.5016 6.08435 19.7953 6.96092C20.2969 7.29373 20.7234 7.69685 21.0328 8.19373Z",
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7672 0.201538C16.8047 0.951538 16.6969 1.64529 16.4812 2.32498C16.1109 3.49216 15.3469 4.36873 14.3812 5.05779C13.7531 5.5031 13.0172 5.6906 12.2344 5.67654C12.0516 5.67185 12 5.61091 11.9953 5.43279C11.9672 4.2281 12.3422 3.16404 13.0922 2.22654C13.9875 1.1156 15.15 0.464038 16.5516 0.215601C16.6125 0.210913 16.6734 0.210913 16.7672 0.201538Z",
    fill: "#4FC0CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.f2952db6fae167ef4bdcdf7136655da2.svg";
export { ForwardRef as ReactComponent };